"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var NewCancelFlight = function NewCancelFlight() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: "18",
    height: "20",
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M6.69998 16.2288L5.64615 15.175L7.94615 12.875L5.64615 10.575L6.69998 9.52117L8.99998\n11.8212L11.3 9.52117L12.3538 10.575L10.0538 12.875L12.3538 15.175L11.3 16.2288L8.99998\n13.9288L6.69998 16.2288ZM2.3077 19.5C1.80257 19.5 1.375 19.325 1.025 18.975C0.675 18.625 0.5\n18.1974 0.5 17.6923V4.30772C0.5 3.80259 0.675 3.37502 1.025 3.02502C1.375 2.67502 1.80257 2.50002\n2.3077 2.50002H3.69233V0.384644H5.23075V2.50002H12.8077V0.384644H14.3076V2.50002H15.6923C16.1974\n2.50002 16.625 2.67502 16.975 3.02502C17.325 3.37502 17.5 3.80259 17.5 4.30772V17.6923C17.5 18.1974\n17.325 18.625 16.975 18.975C16.625 19.325 16.1974 19.5 15.6923 19.5H2.3077ZM2.3077\n18H15.6923C15.7692 18 15.8397 17.9679 15.9038 17.9038C15.9679 17.8397 16 17.7692 16\n17.6923V8.30772H1.99997V17.6923C1.99997 17.7692 2.03202 17.8397 2.09612 17.9038C2.16024 17.9679\n2.23077 18 2.3077 18ZM1.99997 6.80774H16V4.30772C16 4.23079 15.9679 4.16026 15.9038 4.09614C15.8397\n4.03204 15.7692 3.99999 15.6923 3.99999H2.3077C2.23077 3.99999 2.16024 4.03204 2.09612\n4.09614C2.03202 4.16026 1.99997 4.23079 1.99997 4.30772V6.80774Z",
    fill: "#6E6D71"
  }));
};
var _default = NewCancelFlight;
exports.default = _default;